import {
  SCRIPT_DATA_ID,
  GLOBAL_ONLOAD_FUNCTION,
} from '../constants';
import { store } from '@/store/store';
import { setShowRecaptchaV2 } from '@/features/paymentProcess/transactionSlice';

const recaptchaScriptUrl = (siteKey: string, isV2: boolean) => {
  const baseUrl = `https://www.google.com/recaptcha/enterprise.js?onload=${GLOBAL_ONLOAD_FUNCTION}`;
  return isV2 ? baseUrl : `${baseUrl}&render=${siteKey}`;
};

const onLoadHandler = (callback: () => void) => {
  // For V2 (checkbox fallback), we need to wait until grecaptcha is fully initialized
  const checkGrecaptcha = () => {
    if (window.grecaptcha?.enterprise) {
      delete window[GLOBAL_ONLOAD_FUNCTION];
      if (callback) {
        callback();
      }
    } else {
      setTimeout(checkGrecaptcha, 100);
    }
  };

  checkGrecaptcha();
};

export const loadRecaptcha = (siteKey: string, callback: () => void, isV2 = false) => {
  // Check if script is already loaded
  const existingScript = document.querySelector(`script[data-id="${SCRIPT_DATA_ID}"]`);
  if (existingScript) {
    existingScript.remove();
  }

  // Create and load the new script
  window[GLOBAL_ONLOAD_FUNCTION] = () => {
    onLoadHandler(callback);
  };

  const script: HTMLScriptElement = document.createElement('script');
  script.setAttribute('data-id', SCRIPT_DATA_ID);
  const scriptUrl = recaptchaScriptUrl(siteKey, isV2);
  script.setAttribute('src', scriptUrl);
  script.setAttribute('async', 'true');
  script.setAttribute('defer', 'true');

  // If V3 fails, fall back to showing V2
  if (!isV2) {
    script.onerror = () => {
      store.dispatch(setShowRecaptchaV2(true));
    };
  }

  document.head.appendChild(script);
};

export const unloadRecaptcha = () => {
  // Remove the script element
  const script = document.querySelector(`script[data-id="${SCRIPT_DATA_ID}"]`);
  if (script) {
    script.remove();
  }

  // Reset the global callback
  if (window[GLOBAL_ONLOAD_FUNCTION]) {
    window[GLOBAL_ONLOAD_FUNCTION] = () => {
      delete window[GLOBAL_ONLOAD_FUNCTION];
    };
  }

  // Clean up any existing reCAPTCHA elements
  const existingRecaptcha = document.querySelector('.grecaptcha-badge, .g-recaptcha');
  if (existingRecaptcha) {
    existingRecaptcha.remove();
  }

  // Reset the grecaptcha object if it exists
  if (window.grecaptcha) {
    // @ts-expect-error - we're intentionally removing this
    window.grecaptcha = undefined;
  }
};
